import data from "./ProductsData";

export default {
  ...data,
  mounted() {}
};
